// Les deux actions Staff proposent les mêmes 20 motifs.
// Le bouton choisi détermine qui reçoit l'avertissement.
const LIVE_WARNINGS = [
  ["Politesse", "Veuillez rester poli pendant ce live."],
  ["Insultes", "Veuillez cesser les insultes."],
  ["Harcèlement", "Veuillez cesser de harceler les participants."],
  ["Menaces", "Veuillez cesser immédiatement toute menace."],
  ["Discrimination", "Veuillez cesser les propos discriminatoires."],
  ["Propos haineux", "Veuillez cesser les propos haineux."],
  ["Violence", "Veuillez cesser de montrer ou d'encourager la violence."],
  ["Danger", "Veuillez arrêter ce comportement dangereux."],
  ["Cigarette", "Veuillez ne pas fumer pendant ce live."],
  ["Alcool", "Veuillez éviter de montrer une consommation d'alcool."],
  ["Stupéfiants", "Veuillez cesser de montrer ou de promouvoir des stupéfiants."],
  ["Contenu sexuel", "Veuillez cesser les propos ou contenus sexuels inappropriés."],
  ["Mineurs", "Veuillez retirer le contenu inadapté aux mineurs."],
  ["Vie privée", "Veuillez ne pas divulguer d'informations privées."],
  ["Arnaque", "Veuillez cesser toute tentative de tromper les participants."],
  ["Publicité", "Veuillez cesser la publicité non sollicitée."],
  ["Messages répétés", "Veuillez cesser d'envoyer des messages à répétition."],
  ["Liens", "Veuillez cesser de publier des liens non sollicités."],
  ["Informations trompeuses", "Veuillez cesser de diffuser des informations trompeuses."],
  ["Respect des autres", "Veuillez respecter le créateur, les invités et les spectateurs."]
].map(([label, message]) => ({label, message}));

export const HOST_WARNINGS = LIVE_WARNINGS;
export const VIEWER_WARNINGS = LIVE_WARNINGS;
